import { render, staticRenderFns } from "./fork.vue?vue&type=template&id=0c824f9a&"
import script from "./fork.vue?vue&type=script&lang=js&"
export * from "./fork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports